<!-- Toolbar com estrutura atualizada e mais limpa -->
<mat-toolbar color="primary">
  <h1 mat-dialog-title>{{ textoclienteTipo }} {{ clienteCadastroForm.get('clienteId').value || '' }}</h1>
  <span class="flex-spacer"></span>
  <button mat-icon-button (click)="maximizado ? restaurarDialog() : maximizarDialog()" [matTooltip]="maximizado ? 'Minimizar' : 'Expandir'" aria-label="Expandir ou minimizar diálogo">
    <mat-icon>{{ maximizado ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
  </button>
  <button mat-icon-button (click)="fecharDialog()" matTooltip="Fechar" aria-label="Fechar diálogo">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>

<!-- Ações do diálogo -->
<div mat-dialog-actions class="d-flex justify-content-start p-2 border-bottom pb-5">
  <button mat-raised-button color="primary" (click)="salvar()" [disabled]="clienteCadastroForm.invalid" matTooltip="Salvar alterações">
    <mat-icon>save</mat-icon>
    Salvar
  </button>
    <h2 class="pt-3 pb-5 nome-cliente">{{ clienteCadastroForm.get('razaoSocial').value }}</h2>
</div>

<!-- Conteúdo do diálogo -->
<mat-dialog-content class="mat-typography">
  <div class="md-dialog-content pt-3">
    <form [formGroup]="clienteCadastroForm">
      <mat-tab-group (selectedTabChange)="matTabMudouAba($event)" animationDuration="0ms">

        <!-- =================== -->
        <!--      ABA GERAL      -->
        <!-- =================== -->
        <mat-tab label="Geral">
          <div class="p-3">
            <div class="row">
              <div class="col-md-4 col-12 form-group" *ngIf="clienteCadastroForm.get('clienteId').value > 0">
                <mat-checkbox formControlName="ativo">Ativo?</mat-checkbox>
              </div>
              <div class="col-md-4 col-12 form-group">
                <mat-radio-group formControlName="pessoaFisica" aria-label="Tipo de Pessoa">
                  <mat-radio-button [value]="true" class="mr-3">Pessoa Física</mat-radio-button>
                  <mat-radio-button [value]="false">Pessoa Jurídica</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <hr />
            <div class="row">
              <mat-form-field class="col-md-12 col-12">
                <mat-label>Empresa(s)</mat-label>
                    <mat-select formControlName="clienteEmpresas" multiple [compareWith]="compararEmpresas">
                  <mat-option *ngFor="let empresa of empresas" [value]="empresa">
                    {{ empresa.nomeFantasia }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="clienteCadastroForm.get('clienteEmpresas').hasError('required')">
                  Selecione ao menos uma empresa.
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Campos de Pessoa Jurídica -->
            <div *ngIf="!pessoaFisica">
              <div class="row align-items-center">
                <mat-form-field class="col-md-4 col-12">
                  <mat-label>CNPJ do Cliente</mat-label>
                  <input matInput formControlName="cnpj">
                  <button mat-icon-button matSuffix type="button" (click)="buscarParceiro()" aria-label="Buscar dados pelo CNPJ">
                    <mat-icon>search</mat-icon>
                  </button>
                </mat-form-field>
                <div class="col-md-4 col-12" style="margin-top: 2%;">
                  <mat-checkbox formControlName="isento">Isento de Inscrição Estadual?</mat-checkbox>
                </div>
                <mat-form-field class="col-md-2 col-12">
                  <mat-label>Inscrição Estadual</mat-label>
                  <input matInput formControlName="inscEstadual">
                </mat-form-field>

              </div>
            </div>

            <!-- Campos de Pessoa Física -->
            <div *ngIf="pessoaFisica">
              <div class="row">
                <mat-form-field class="col-md-4 col-12">
                  <mat-label>CPF do Cliente</mat-label>
                  <input matInput formControlName="cpf">
                </mat-form-field>
                <mat-form-field class="col-md-4 col-12">
                  <mat-label>RG</mat-label>
                  <input matInput formControlName="rg">
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <mat-form-field class="col-md-6 col-12">
                <mat-label>Razão Social (Nome)</mat-label>
                <input matInput formControlName="razaoSocial" required>
              </mat-form-field>
              <mat-form-field class="col-md-6 col-12" *ngIf="!pessoaFisica">
                <mat-label>Nome Fantasia</mat-label>
                <input matInput formControlName="nomeFantasia">
              </mat-form-field>
              <mat-form-field class="col-md-6 col-12" *ngIf="pessoaFisica">
                <mat-label>Data de Nascimento</mat-label>
                <input matInput [matDatepicker]="pickerNascimento" formControlName="dataNascimento">
                <mat-datepicker-toggle matSuffix [for]="pickerNascimento"></mat-datepicker-toggle>
                <mat-datepicker #pickerNascimento></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="row" *ngIf="!pessoaFisica">
              <mat-form-field class="col-md-4 col-12">
                <mat-label>Inscrição Municipal</mat-label>
                <input matInput formControlName="inscMunicipial">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-12">
                <mat-label>Inscrição Suframa</mat-label>
                <input matInput formControlName="inscSuframa">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-12">
                <mat-label>Código de Regime Tributário</mat-label>
                <mat-select formControlName="codRegimeTributario">
                  <mat-option [value]="1">1 - Simples Nacional</mat-option>
                  <mat-option [value]="2">2 - Lucro Presumido</mat-option>
                  <mat-option [value]="3">3 - Lucro Real</mat-option>
                  <mat-option [value]="4">4 - MEI</mat-option>
                  <mat-option [value]="5">5 - Administração Pública Federal</mat-option>
                  <mat-option [value]="6">6 - Administração Pública Estadual</mat-option>
                  <mat-option [value]="7">7 - Administração Pública Municipal</mat-option>
                  <mat-option [value]="8">8 - Administração Pública Distrital</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <hr>
            <h4>Endereço Principal</h4>
            <div class="row">
              <mat-form-field class="col-md-2 col-12">
                <mat-label>CEP</mat-label>
                <input matInput formControlName="cep" (blur)="consultarCep(clienteCadastroForm.value.cep, false)">
              </mat-form-field>
              <mat-form-field class="col-md-5 col-12">
                <mat-label>Logradouro</mat-label>
                <input matInput formControlName="logradouro">
              </mat-form-field>
              <mat-form-field class="col-md-2 col-12">
                <mat-label>Número</mat-label>
                <input matInput formControlName="numero">
              </mat-form-field>
              <mat-form-field class="col-md-3 col-12">
                <mat-label>Complemento</mat-label>
                <input matInput formControlName="complemento">
              </mat-form-field>
              <mat-form-field class="col-md-3 col-12">
                <mat-label>Bairro</mat-label>
                <input matInput formControlName="bairro">
              </mat-form-field>
              <mat-form-field class="col-md-3 col-12">
                <mat-label>País</mat-label>
                <mat-select formControlName="paisId">
                  <mat-option *ngFor="let pais of paises" [value]="pais.paisId">{{ pais.descPais }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-2 col-12">
                <mat-label>UF</mat-label>
                <mat-select formControlName="ufId">
                  <mat-option *ngFor="let uf of ufs" [value]="uf.ufId">{{ uf.descUF }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="col-md-4 col-12">
                <mat-label>Município</mat-label>
                <mat-select formControlName="municipioId">
                  <mat-option *ngFor="let municipio of municipios" [value]="municipio.municipioId">{{ municipio.descricao }}</mat-option>
                </mat-select>
                <mat-error *ngIf="clienteCadastroForm.get('municipioId').hasError('required')">
                  Município é obrigatório.
                </mat-error>
              </mat-form-field>
            </div>

            <hr>
            <h4>Contato Principal</h4>
            <div class="row">
              <mat-form-field class="col-md-4 col-12">
                <mat-label>Telefone</mat-label>
                <input matInput formControlName="telefone">
              </mat-form-field>
              <mat-form-field class="col-md-4 col-12">
                <mat-label>E-mail</mat-label>
                <input type="email" matInput formControlName="email">
                <mat-error *ngIf="clienteCadastroForm.get('email').hasError('email')">
                  Formato de e-mail inválido.
                </mat-error>
                <mat-error *ngIf="clienteCadastroForm.get('email').hasError('required')">
                  E-mail é obrigatório.
                </mat-error>
              </mat-form-field>
              <mat-form-field class="col-md-4 col-12">
                <mat-label>Indicação</mat-label>
                <input matInput formControlName="indicacao">
              </mat-form-field>
            </div>

            <hr />
            <div class="row">
              <div class="col-12">
                <mat-checkbox formControlName="localEntregaAtivo">Local de Entrega diferente do principal?</mat-checkbox>
              </div>
            </div>

            <div *ngIf="localEntregaAtivo">
              <hr>
              <h4>Endereço de Entrega</h4>
              <div class="row">
                <mat-form-field class="col-md-2 col-12">
                  <mat-label>CEP</mat-label>
                  <input matInput formControlName="cepEntrega" (blur)="consultarCep(clienteCadastroForm.value.cepEntrega, true)">
                </mat-form-field>
                <mat-form-field class="col-md-5 col-12">
                  <mat-label>Logradouro</mat-label>
                  <input matInput formControlName="logradouroEntrega">
                </mat-form-field>
                <mat-form-field class="col-md-2 col-12">
                  <mat-label>Número</mat-label>
                  <input matInput formControlName="numeroEntrega">
                </mat-form-field>
                <mat-form-field class="col-md-3 col-12">
                  <mat-label>Complemento</mat-label>
                  <input matInput formControlName="complementoEntrega">
                </mat-form-field>
                <mat-form-field class="col-md-3 col-12">
                  <mat-label>Bairro</mat-label>
                  <input matInput formControlName="bairroEntrega">
                </mat-form-field>
                <mat-form-field class="col-md-3 col-12">
                  <mat-label>UF</mat-label>
                  <mat-select formControlName="ufEntregaId">
                    <mat-option *ngFor="let uf of ufs" [value]="uf.ufId">{{ uf.descUF }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-3 col-12">
                  <mat-label>Município</mat-label>
                  <mat-select formControlName="municipioEntregaId">
                    <mat-option *ngFor="let municipio of localEntregaMunicipios" [value]="municipio.municipioId">{{ municipio.descricao }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>

        <!-- =================== -->
        <!-- ABA FISCAL/CONTÁBIL -->
        <!-- =================== -->
        <mat-tab label="Fiscal e Contábil" *ngIf="clienteCadastroForm.get('clienteId').value > 0">
          <div class="p-3">

            <!-- Envolvemos todas as seções em um 'mat-accordion' para que apenas uma fique aberta por vez -->
            <mat-accordion multi="false">

              <!-- PAINEL 1: IMPOSTOS -->
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <strong>Fiscal - NFS-e</strong>
                  </mat-panel-title>
                  <mat-panel-description>
                    Clique para expandir e configurar os impostos
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <p class="text-muted">Selecione os impostos, as empresas correspondentes e se o imposto será retido.</p>
                <div class="table-responsive">
                  <table mat-table [dataSource]="dataSourceNfse" class="impostos-table">

                    <!-- Coluna Retido -->
                    <ng-container matColumnDef="retido">
                      <th mat-header-cell *matHeaderCellDef> Retido? </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.retido"
                                      [ngModelOptions]="{standalone: true}">
                        </mat-checkbox>
                      </td>
                    </ng-container>

                    <!-- Coluna Imposto -->
                    <ng-container matColumnDef="tipoImposto">
                      <th mat-header-cell *matHeaderCellDef> Imposto </th>
                      <td mat-cell *matCellDef="let element">
                        {{ element.tipoImposto }}
                      </td>
                    </ng-container>

                    <!-- Coluna Empresas -->
                    <ng-container matColumnDef="empresas">
                      <th mat-header-cell *matHeaderCellDef> Empresas </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-select multiple 
                                      [(ngModel)]="element.empresasSelecionadas" 
                                      [compareWith]="compararEmpresas"
                                      [disabled]="!element.retido"
                                      [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let empresa of element.empresasDisponiveis" [value]="empresa">
                              {{ empresa.nomeFantasia }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>
                </div>

                <mat-form-field style="width: 100%;">
                  <mat-label>Observações para NFSE</mat-label>
                  <textarea matInput formControlName="textoNfse" cols="12" rows="4"></textarea>
                  <mat-hint>Essas observações serão adicionadas na descrição dos serviços prestados para esse cliente na NFS-e.</mat-hint>
                </mat-form-field>

              </mat-expansion-panel>

              <!-- PAINEL 2: CONTÁBIL -->
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <strong>Contábil</strong>
                  </mat-panel-title>
                  <mat-panel-description>
                    Configurar a conta contábil do cliente
                  </mat-panel-description>
                </mat-expansion-panel-header>
                
                <mat-form-field class="col-12">
                  <mat-label>Conta Contábil</mat-label>
                  <input type="text" matInput [matAutocomplete]="autoContaContabil" formControlName="contaContabilAutoComplete">
                  <mat-autocomplete #autoContaContabil="matAutocomplete" (optionSelected)="determinarContaContabil($event.option.value)">
                    <mat-option *ngFor="let conta of contasContabeis" [value]="conta">
                      {{ conta.numero }} - {{ conta.descricao }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </mat-expansion-panel>

              <!-- PAINEL 3: DADOS DO CONTADOR -->
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <strong>Dados do Contador</strong>
                  </mat-panel-title>
                  <mat-panel-description>
                    Informações adicionais do contador responsável
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <ng-container *ngIf="clienteContadorForm">
                  <form [formGroup]="clienteContadorForm">
                    <div class="form-group col-12 mt-3">
                      <mat-checkbox formControlName="contadorCheckbox">
                        Deseja armazenar os dados do contador deste cliente?
                      </mat-checkbox>
                    </div>
                    <div *ngIf="clienteContadorForm.get('contadorCheckbox').value">
                      <div class="row">
                        <mat-form-field class="col-md-4 col-12">
                          <mat-label>CNPJ</mat-label>
                          <input matInput formControlName="cnpj" (blur)="buscarParceiroContador()">
                        </mat-form-field>
                        <mat-form-field class="col-md-4 col-12">
                          <mat-label>Telefone</mat-label>
                          <input matInput formControlName="telefone">
                        </mat-form-field>
                      </div>
                      <div class="row">
                        <mat-form-field class="col-md-6 col-12">
                          <mat-label>Razão Social (Nome)</mat-label>
                          <input matInput formControlName="razaoSocial">
                        </mat-form-field>
                        <mat-form-field class="col-md-6 col-12">
                          <mat-label>Nome Fantasia</mat-label>
                          <input matInput formControlName="nomeFantasia">
                        </mat-form-field>
                      </div>
                      <div class="row">
                        <mat-form-field class="col-md-4 col-12">
                          <mat-label>País</mat-label>
                          <mat-select formControlName="paisId">
                            <mat-option *ngFor="let pais of paises" [value]="pais.paisId">{{ pais.descPais }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-md-4 col-12">
                          <mat-label>UF</mat-label>
                          <mat-select formControlName="ufId">
                            <mat-option *ngFor="let uf of ufs" [value]="uf.ufId">{{ uf.descUF }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-form-field class="col-md-4 col-12">
                          <mat-label>Município</mat-label>
                          <mat-select formControlName="municipioId">
                            <mat-option *ngFor="let municipio of municipios" [value]="municipio.municipioId">{{ municipio.descricao }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </form>
                </ng-container>
              </mat-expansion-panel>

            </mat-accordion>          

          </div>
        </mat-tab>


        <!-- =================== -->
        <!--     ABA CONTATOS    -->
        <!-- =================== -->
        <mat-tab label="Contatos" *ngIf="clienteCadastroForm.get('clienteId').value > 0">
          <div class="p-3">
            <button (click)="modalContato(0)" mat-raised-button color="accent" class="mb-3">
              <mat-icon>add</mat-icon> Adicionar Contato
            </button>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Ações</th>
                    <th>Nome</th>
                    <th>Sobrenome</th>
                    <th>WhatsApp</th>
                    <th>Celular</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let contato of contatos; trackBy: trackByFn">
                    <td class="actions">
                      <button mat-icon-button (click)="modalContato(contato.contatoId)" matTooltip="Editar"><mat-icon>edit</mat-icon></button>
                      <button mat-icon-button color="warn" (click)="confirmarExclusaoContato(contato.contatoId)" matTooltip="Excluir"><mat-icon>delete</mat-icon></button>
                    </td>
                    <td>{{ contato.nome }}</td>
                    <td>{{ contato.sobreNome }}</td>
                    <td>{{ contato.whatsApp }}</td>
                    <td>{{ contato.celular }}</td>
                    <td>{{ contato.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- =================== -->
        <!-- ABA DADOS BANCÁRIOS -->
        <!-- =================== -->
        <mat-tab label="Dados Bancários" *ngIf="clienteCadastroForm.get('clienteId').value > 0 && clienteCadastroForm.get('clienteTipo').value == 0">
          <div class="p-3">
            <button (click)="modalDadoBancario(0)" mat-raised-button color="accent" class="mb-3">
              <mat-icon>add</mat-icon> Adicionar Dados Bancários
            </button>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Ações</th>
                    <th>Banco</th>
                    <th>Agência</th>
                    <th>Conta</th>
                    <th>Tipo</th>
                    <th>Favorecido</th>
                    <th>CNPJ/CPF</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let dado of dadosBancarios; trackBy: trackByFn">
                    <td class="actions">
                      <button mat-icon-button (click)="modalDadoBancario(dado.dadoBancarioId)" matTooltip="Editar"><mat-icon>edit</mat-icon></button>
                      <button mat-icon-button color="warn" (click)="confirmarExclusaoDadoBancario(dado.dadoBancarioId)" matTooltip="Excluir"><mat-icon>delete</mat-icon></button>
                    </td>
                    <td>{{ dado.bancoDescricao }}</td>
                    <td>{{ dado.agenciaNumero }}</td>
                    <td>{{ dado.contaCorrenteNumero }}</td>
                    <td>{{ dado.dadoBancarioTipo == 0 ? 'Conta Corrente' : 'Conta Poupança' }}</td>
                    <td>{{ dado.favorecidoNome }}</td>
                    <td>{{ dado.favorecidoCpf || dado.favorecidoCnpj }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- =================== -->
        <!--     ABA HISTÓRICO   -->
        <!-- =================== -->
        <mat-tab label="Histórico" *ngIf="clienteCadastroForm.get('clienteId').value > 0">
          <div class="p-3">
            <button (click)="ModalClienteHistorico(0)" mat-raised-button color="accent" class="mb-3">
              <mat-icon>add</mat-icon> Adicionar Histórico
            </button>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Ações</th>
                    <th>Usuário</th>
                    <th>Data</th>
                    <th>Título</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let historico of clienteHistoricos; trackBy: trackByFn">
                    <td class="actions">
                      <button mat-icon-button (click)="ModalClienteHistorico(historico.clienteHistoricoId)" matTooltip="Editar"><mat-icon>edit</mat-icon></button>
                    </td>
                    <td>{{ historico.usuario }}</td>
                    <td>{{ historico.dataCriacao | date:'dd/MM/yyyy' }}</td>
                    <td>{{ historico.titulo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- =================== -->
        <!--   ABA ASSINATURAS   -->
        <!-- =================== -->
        <mat-tab label="Assinaturas" *ngIf="clienteCadastroForm.get('clienteId').value > 0 && clienteCadastroForm.get('clienteTipo').value == 0">
          <div class="p-3">
            <button (click)="ModalClienteServico(0)" mat-raised-button color="accent" class="mb-3">
              <mat-icon>add</mat-icon> Adicionar Assinatura
            </button>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Ações</th>
                    <th>Status</th>
                    <th>Serviço</th>
                    <th>Qtd.</th>
                    <th>Vlr. Unit.</th>
                    <th>Vlr. Total</th>
                    <th>Contratação</th>
                    <th>Último Fat.</th>
                    <th>Próx. Fat.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let servico of clienteServicos; trackBy: trackByFn">
                    <td class="actions">
                      <button mat-icon-button (click)="ModalClienteServico(servico.clienteServicoId)" matTooltip="Editar"><mat-icon>edit</mat-icon></button>
                      <button mat-icon-button *ngIf="servico.clienteServicoStatus != 99" color="warn" (click)="confirmarExclusaoClienteServico(servico.clienteServicoId)" matTooltip="Cancelar Assinatura"><mat-icon>delete</mat-icon></button>
                    </td>
                    <td>{{ servico.clienteServicoStatus == 99 ? 'Cancelado' : 'Ativo' }}</td>
                    <td>{{ servico.produtoDescricao }}</td>
                    <td>{{ servico.quantidade }}</td>
                    <td>{{ servico.valorUnitario | currency:'BRL' }}</td>
                    <td>{{ servico.valorTotal | currency:'BRL' }}</td>
                    <td>{{ servico.dataContratacao | date:'dd/MM/yyyy' }}</td>
                    <td>{{ servico.dataUltimaRenovacao | date:'dd/MM/yyyy' }}</td>
                    <td>{{ servico.dataProximaRenovacao | date:'dd/MM/yyyy' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- =================== -->
        <!--       ABA SOC       -->
        <!-- =================== -->
        <mat-tab label="SOC" *ngIf="clienteCadastroForm.get('clienteId').value > 0 && clienteCadastroForm.get('clienteTipo').value == 0 && integracao">
          <div class="p-3">
            <div class="row">
              <mat-form-field class="col-md-6 col-12">
                <mat-label>Código da Empresa no SOC</mat-label>
                <input matInput formControlName="codigoEmpresaSoc">
                <mat-hint>Utilizado para integrações com o sistema SOC.</mat-hint>
              </mat-form-field>
              <mat-form-field class="col-md-6 col-12">
                <mat-label>Código da Unidade no SOC</mat-label>
                <input matInput formControlName="codigoUnidadeSoc">
                <mat-hint>Para identificar se a empresa é filial ou matriz.</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
    </form>
  </div>
</mat-dialog-content>

<!-- Estilos (podem ser movidos para um arquivo .scss) -->
<style>
  .flex-spacer { flex: 1 1 auto; }
  .p-3 { padding: 1.5rem; }
  .pb-0 { padding-bottom: 0; }
  .mb-3 { margin-bottom: 1.5rem; }
  .mr-3 { margin-right: 1.5rem; }
  .border-bottom { border-bottom: 1px solid rgba(0,0,0,.12); }
  .actions button { margin-right: 8px; }
  .impostos-table { width: 100%; }
  .impostos-table .mat-form-field-appearance-outline .mat-form-field-wrapper {margin: 0;padding: 0;}
  .nome-cliente{padding-top: 1%; padding-left: 3%;}
  .mat-dialog-actions {margin-bottom: 2%;}
  .mat-expansion-panel {margin-bottom: 1%;}
  .mat-expansion-panel:not([class*="mat-elevation-z"]) {box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0), 0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);}
  .table-responsive {width: 100%;overflow-x: auto;-webkit-overflow-scrolling: touch; /* Melhora a rolagem em iOS */}
  .impostos-table {width: 100%;border-collapse: collapse; }
  .impostos-table th.mat-header-cell {  font-size: 14px;
  font-weight: 500; /* Um pouco mais de peso que o normal */
  color: rgba(0, 0, 0, 0.65); /* Cor mais suave que o preto puro */
  background-color: #f9f9f9; /* Fundo cinza bem claro para destacar */
  text-align: left;
  padding: 12px 16px !important;
  border-bottom: 2px solid #e0e0e0; /* Linha inferior mais grossa */
}

/* Células da tabela (td) */
.impostos-table td.mat-cell {
  padding: 0px 8PX !important;
  border-bottom: 1px solid #eeeeee; /* Linha separadora suave */
  vertical-align: middle; /* Alinha verticalmente o conteúdo no centro */
}

/* Efeito de hover nas linhas para dar feedback ao usuário */
.impostos-table tr.mat-row:hover {
  background-color: #f5f5f5;
}

/* Remove o padding extra do mat-form-field para que ele não "estique" a linha */
.impostos-table .mat-form-field-wrapper {
  padding-bottom: 0;
}

/* Deixa o mat-select um pouco mais sutil */
.impostos-table .mat-form-field-appearance-outline .mat-form-field-outline {
  color: rgba(0, 0, 0, 0.2);
}

.impostos-table .mat-form-field-appearance-outline:hover .mat-form-field-outline {
  color: rgba(0, 0, 0, 0.87);
}

/* Mensagem de "Nenhuma linha encontrada" quando a tabela está vazia */
.impostos-table .mat-mdc-no-data-row td {
  text-align: center;
  color: rgba(0, 0, 0, 0.54);
  padding: 24px;
  font-style: italic;
}

</style>
